import { Outlet } from "react-router-dom";

const BackendPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default BackendPage;
